import { render, staticRenderFns } from "./commonDrugs.vue?vue&type=template&id=243f4690&scoped=true"
import script from "./commonDrugs.vue?vue&type=script&lang=js"
export * from "./commonDrugs.vue?vue&type=script&lang=js"
import style0 from "./commonDrugs.vue?vue&type=style&index=0&id=243f4690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f4690",
  null
  
)

export default component.exports